import { ChangeEvent, FC, ReactNode } from 'react';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
} from '@mui/material';

type WaveUIInputProps = OutlinedInputProps & {
  name: string;
  label: ReactNode;
  value?: string;
  placeholder: string;
  helperText?: string;
  error?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const WaveUIInput: FC<WaveUIInputProps> = ({
  name,
  label,
  value,
  onChange,
  placeholder,
  helperText,
  fullWidth = true,
  error,
  ...props
}) => {
  return (
    <FormControl
      variant='outlined'
      required={props.required}
      error={error}
      fullWidth={fullWidth}
    >
      <InputLabel htmlFor={`id_${name}`}>{label}</InputLabel>
      <OutlinedInput
        {...props}
        id={`id_${name}`}
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete='off'
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default WaveUIInput;
